import {getApiUrl} from './api'
import {CUSTOMER_API_URL} from './env'

// client-side equivalent of getTriggerEndpoint
export const getTriggerEndpointWb = ({
  organisationId,
  environmentId,
  flowConfigId,
  secret
}: {
  organisationId: string
  environmentId: string
  flowConfigId: string
  secret: string
}) =>
  `${getApiUrl(CUSTOMER_API_URL)(
    organisationId
  )}/${environmentId}/connector/${flowConfigId}/${secret}`
